import {initTableSelection} from './Table';

const initializedTables = new WeakSet();

export const initializeSelectableTables = root => {
    root.querySelectorAll('table.selectable').forEach(table => {
        if (initializedTables.has(table)) {
            return;
        }

        initializedTables.add(table);

        initTableSelection(table);
    });
};
